<form [formGroup]="changePassword" (submit)="changeAccountPassword()">
  <mat-icon class="close-icon" mat-dialog-close>close</mat-icon>
  <h4 mat-dialog-title>Change Password</h4>
  <mat-dialog-content>
    <div class="change-password-wrapper">
      <mat-form-field>
        <mat-label>Old Password:</mat-label>
        <input matInput type="password" name="oldPassword" aria-label="old password" required
          formControlName="oldPassword" />
        @if(changePassword.get('oldPassword')?.invalid &&
        changePassword.get('oldPassword')?.touched) {
        <mat-error>
          Please enter Old password.
        </mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>New Password:</mat-label>
        <input matInput type="password" name="newPassword" aria-label="new password" required
          formControlName="newPassword" />
        @if(changePassword.get('newPassword')?.invalid &&
        changePassword.get('newPassword')?.touched) {
        <mat-error class="error-text">
          Please enter New password.
        </mat-error>
        }
      </mat-form-field>
      <div [ngClass]="passwordChanged().isSuccess ? '' : 'password-changed-text-error' " class="password-changed-text-wrapper">
        <span> {{passwordChanged().message}}</span>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-flat-button cdkFocusInitial type="submit" [disabled]="changePassword.invalid || isDisable">
      Change Password
    </button>
    <button mat-stroked-button cdkFocusInitial mat-dialog-close>
      Close
    </button>
  </mat-dialog-actions>
</form>